module.exports = __webpack_public_path__ + "img/num7.367fe2b2.svg";